import Link from 'next/link';

const Variant = ({ options, value, getFilterUrl, isAvailable, filterKey }) => (
  <ul className="flex flex-wrap gap-[8px]">
    {options.map(({ label }) => {
      return (
        <li data-insights-filter={`${filterKey}:${label}`} key={label}>
          <Link href={getFilterUrl(label)} shallow passHref>
            <a
              href="_"
              role="button"
              className={`pointer-events-auto flex h-[36px] w-[36px] min-w-fit items-center justify-center border-blue pt-[2px] text-center text-[12px] uppercase data-[disabled]:pointer-events-none data-[disabled]:opacity-30 ${
                value.includes(label) ? 'border-[3px]' : 'border lg:hover:border-[3px]'
              }`}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...(!isAvailable(label) ? { 'data-disabled': true } : {})}
            >
              {label}
            </a>
          </Link>
        </li>
      );
    })}
  </ul>
);

export default Variant;
